import dayjs, { Dayjs } from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timeZonePlugin from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(timeZonePlugin);
dayjs.extend(duration);

const convertToLocalDate = (date: string): any => dayjs.utc(date).local();

const timeOfBooking = (time: string): string => {
  const formattedTime = dayjs(time, 'HH:mm:ss').format('h:mma');
  if (formattedTime.toLowerCase() === 'invalid date') {
    return 'Sold';
  }
  return formattedTime;
};

const dayOfWeek = (date: string): string => dayjs(date).format('ddd');

const dayAndTimeLong = (date: string, time: string): string =>
  `${dayjs(date).format('D MMM')} at ${timeOfBooking(time)}`;

const dayOfMonth = (date: string): string => `${dayjs(date).format('D MMM')}`;

const dayOfMonthShort = (date: string): string => `${dayjs(date).format('D')}`;

// 15 Aug 2018
const dayMonthYear = (date: string): string =>
  `${dayjs(date).format('D MMM YYYY')}`;

// August 2018
const monthYear = (date: string): string =>
  `${dayjs(date).format('MMMM YYYY')}`;

const getCountDownString = (
  time: string,
  timeZone: string,
): string | boolean => {
  const cutOffLocalTime = dayjs.utc(time).local();
  const now = dayjs().subtract(1, 'minute');
  const durationDiff = dayjs.duration(cutOffLocalTime.diff(now));
  const cityTimezone = dayjs().tz(timeZone).format('z');
  const browserTimezone = dayjs().format('z');
  const timeFormat = cityTimezone === browserTimezone ? 'h:mma' : 'h:mma z';

  if (!isEmpty(durationDiff)) {
    const times = [];

    const hours = durationDiff.hours();
    if (hours > 0) {
      times.push(`${hours} hour${hours === 1 ? '' : 's'}`);
    }

    const minutes = durationDiff.minutes();
    if ((hours > 0 && minutes > 0) || minutes > 1) {
      times.push(`${minutes} minute${minutes === 1 ? '' : 's'}`);
    }

    const seconds = durationDiff.seconds();
    if (!times.length && seconds > 1 && hours === 0 && minutes === 1) {
      times.push(`${+seconds} seconds`);
    }

    if (!times.length) {
      times.push(`1 second`);
    }

    if (times.length > 0) {
      return `Quick, only ${times.join(
        ', ',
      )} left to book this table! Cut off time is ${cutOffLocalTime.format(
        timeFormat,
      )}.`;
    }

    // return `Time is running out to book this table! Cut off time is ${cutOffLocalTime.format(
    //   timeFormat
    // )}.`;
  }

  return false;
};

const getDaysOut = (date: string, today: Dayjs): number => {
  const daysOut = dayjs(date).diff(today, 'day') + 1;
  return daysOut;
};

export {
  timeOfBooking,
  getCountDownString,
  dayOfWeek,
  dayAndTimeLong,
  dayOfMonth,
  dayOfMonthShort,
  dayMonthYear,
  monthYear,
  convertToLocalDate,
  getDaysOut,
};
